module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "help"
  }, [_h('p', ["产品采用BIA（生物电阻测量法）技术进行人体成分的测量，如下可能会导致测量误差哦！请参考如下正确的方式测量。"]), " ", _h('div', {
    staticClass: "clearfix rol-div"
  }, [_h('div', [_h('img', {
    staticClass: "measurement",
    attrs: {
      "alt": "image",
      "src": require("assets/images/measurements/measurement01.png")
    }
  })]), " ", _h('div', ["正确测量方式，光脚测量，两脚分别站在两边的导电极片上，并保持身体稳定不晃动。"])]), " ", _h('div', {
    staticClass: "clearfix rol-div"
  }, [_h('div', [_h('img', {
    staticClass: "measurement",
    attrs: {
      "alt": "image",
      "src": require("assets/images/measurements/measurement02.png")
    }
  })]), " ", _h('div', ["双脚距离过大或靠近边缘，会导致体脂率无法测量或测量不准。"])]), " ", _h('div', {
    staticClass: "clearfix rol-div"
  }, [_h('div', [_h('img', {
    staticClass: "measurement",
    attrs: {
      "alt": "image",
      "src": require("assets/images/measurements/measurement03.png")
    }
  })]), " ", _h('div', ["双脚过于紧挨并拢，会导致体脂率测量不准。"])]), " ", _h('div', {
    staticClass: "clearfix info"
  }, [_h('div', [_h('img', {
    attrs: {
      "height": "25px",
      "width": "25px",
      "alt": "image",
      "src": require("assets/images/measurements/info01.png")
    }
  })]), " ", _h('div', ["温馨提示"])]), " ", _h('div', {
    staticClass: "last-content"
  }, ["每天测量尽量在同一个位置会提高测量精度！"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70de5799!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/help.vue
// module id = 26
// module chunks = 1